<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}


</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">A Bed, a Chair, and a Table</p>
      </b-col>
    </b-row>



    <b-row class='content'>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Publication, editorial, interviews</p>
        <p>A Bed, a Chair, and a Table is a publication about the Poortgebouw, a former squat and vibrant living community located in the South of Rotterdam. In this book, oral histories from inside and outside the building are interlaced with material from various institutional and personal archives. By bringing together these tales of resilience, political struggle, frustration and friendship, with historical documents, this book brings forward new perspectives about Poortgebouw's unique history and its importance in the contemporary city.
        </p>
        <p>My focus in working on this publication was collecting stories and interviews from people with a strong connection to the Poortgebouw. These voices were then interlaced together to create a narrative, and to build the story of Poortgebouw's past 30 years, as well as its future.</p>
        <p>This <a href="https://issue.xpub.nl/04/">publication</a> was developed together with Natasha Berting, Angeliki Diakrousi, Joca van der Horst, Alex Roidl, Elisa Chaudet and Zalán Szakács.</p>




      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/bed/bed.png"></b-img>

      </b-col>
      <b-col md="4">
      <b-img class="img-fluid" src="media/bed/inside_bed.jpg"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/bed/stack_bed.jpg"></b-img>

      </b-col>

    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'BedchairtablePage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
